<template>
  <ValidationProvider
    ref="validationProvider"
    v-slot="{ errors, valid, validated }"
    :name="name"
    mode="passive"
    :rules="getValidation"
    slim
  >
    <basic-form-group
      :id="id"
      :label-is-up="labelIsUp"
      :label="$attrs.label"
      :hint="$attrs.hint"
      :required="$attrs.required"
      :horizontal="$attrs.horizontal"
    >
      <currency-input
        :id="id"
        :value.sync="model"
        :currency="currency"
        :locale="locale"
        :min="$attrs.min"
        :max="$attrs.max"
        :class="{'is-invalid': !valid && validated}"
        :name="name"
        class="form-control"
        @input="setModel"
        @blur="onBlur"
      />
    </basic-form-group>
  </ValidationProvider>
</template>

<script>
import basicComponentMixin from './basic-component-mixin.js'
export default {
  name: 'BasicCurrencyInput',
  mixins: [basicComponentMixin],
  data: () => ({
    currency: 'EUR',
    locale: 'de-DE',
    formattedValue: ''
  }),

  methods: {
    setModel (event) {
      this.model = event
      if (this.$refs.validationProvider) {
        this.$refs.validationProvider.validate(event)
      }
    },
    onBlur () {
      this.$emit('blur', this.model)
    }
  }
}
</script>
